

export const SET_ARTICLE_LIST_DATA = "SET_ARTICLE_LIST_DATA";
export const ArticleListAction = (data) => {
	return{
		type: SET_ARTICLE_LIST_DATA,
		payload: data,
	}
}